module.exports = __webpack_public_path__ + "img/prep.bb8d9881.jpg";